import { Dialog } from 'antd-mobile';
import _ from 'lodash';

import {
  message_update,
  handle_notification,
  message_withdraw,
  // show_global_dialog,
  show_global_popup
} from '@/actions'
import {
  JOIN_ROOM,
  LEAVE_ROOM,
  CHAT_TO_ONE,
  FILE_UPLOAD,
  NOTIFICATION,
  CALL_TO_ONE,
  LOGOUT_CHAT_CLOSE
} from '@/actions/actionType'
import { getUrls } from '@/utils/getUrls';
import { getAuthId } from '@/utils/localStorage';
import changeName from '@/utils/changeName';
import EventEmitter from '@/utils/eventEmitter';
import { isRoomPinned } from '@/utils/pinnedRooms';
import { emitterEvent } from '@/Constant';
import { CONSULT_END_CONFIRM } from '../actions/actionType';
import MomentDiffZone from '@/hooks/useMomentDiffZone';


// 获取id，重新创建socket
function reCreateSocket(store, authId) {
  const { socketUrl } = getUrls();
  // authId = _.get(store.getState(), ['baseInfo', 'authId', '']) || authId;
  if (authId) {
    console.log('****socket********', socketUrl, authId);
    const socket = io(socketUrl + authId, { autoConnect: false, reconnection: true, reconnectionAttempts: Infinity, reconnectionDelay: 1000, reconnectionDelayMax: 5000, forceNew: false, transports: ['websocket', 'polling'] });
    socket.open();
    return socket;
  }
}

// 是否是消息的是接受者,发送的消息来源是不是当前聊天的对象
function isNeedUpdateMessage(store, data, role) {
  const baseInfo = store.getState().baseInfo;
  const chatAuthId = store.getState().chatInfo.chatAuthId;
  const authId = baseInfo[role] && baseInfo[role].authId;
  // console.log(authId, data.toUserId, chatAuthId, data.fromUserId);
  // return authId === data.toUserId && chatAuthId === data.fromUserId;
  return authId !== data.fromUserId;
}

function handleNotification(history, message, next) {
  const { type } = message
  console.log('handleNotification', type);
  const pathname = window.location.pathname;
  switch (type) {
    case 'APPOINT_ROOM_SUCCESS':
      let roomUrl = message.roomUrl;
      if (roomUrl) {
        history.push(roomUrl)
        window.location.reload();
      }
      break;
    case 'APPOINT_ADD':
    case 'APPOINT_TIMESLOT_ADD':
    case 'APPOINT_TIMESLOT_REMOVE':
    case 'APPOINT_CANCEL':
      EventEmitter.emit(emitterEvent.APPOINT_UPDATE);
      break;
    case 'CONSULT_END_CONFIRM':
      EventEmitter.emit(emitterEvent.CONSULT_END_CONFIRM, message);
      break;
    case 'CONSULT_WAIT_EVALUATE':
      EventEmitter.emit(emitterEvent.CONSULT_WAIT_EVALUATE, message);
      break;
    case 'STAFF_FORM_TASK_SUCCESS':
      EventEmitter.emit(emitterEvent.STAFF_FORM_TASK_SUCCESS, message);
      break;
    case 'STAFF_FORM_TASK_AI_REPORT':
      EventEmitter.emit(emitterEvent.STAFF_FORM_TASK_AI_REPORT, message);
      const isOnAiReportPage = pathname.includes('/ai-report') || 
                               pathname.includes('/ai-report-transition');
      
      if (!isOnAiReportPage) {
        next(show_global_popup(message));
      }
      break;
    case 'EVALUATION_REPORT_TO_STAFF':
      EventEmitter.emit(emitterEvent.EVALUATION_REPORT_TO_STAFF, message);
      break;
    case 'ACTIVITY_TEAM_REPORT_GENERATED':
    case 'ACTIVITY_REPORT_GENERATED':
      EventEmitter.emit(emitterEvent[type], message.activityId);
      if (pathname.indexOf('/diy-doll-group')) {
        // 团体报告不处理消息显示
        return;
      }
      next(show_global_popup(message));
      break;
    case 'WORK_ORDER_TOOK':
      console.log('WORK_ORDER_TOOK', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_TOOK, message);
      break;
    case 'WORK_ORDER_RELEASED':
      console.log('WORK_ORDER_RELEASED', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_RELEASED, message);
      break;
    case 'WORK_ORDER_COMPLETED':
      console.log('WORK_ORDER_COMPLETED', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_COMPLETED, message);
      break;
    case 'WORK_ORDER_COMPLETED_BY_CONSULTANT':
      console.log('WORK_ORDER_COMPLETED_BY_CONSULTANT', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_COMPLETED_BY_CONSULTANT, message);
      break;
    case 'WORK_ORDER_CREATED':
      console.log('WORK_ORDER_CREATED', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_CREATED, message);

      const workOrderPathname = window.location.pathname;
      const isOnWorkOrderPage = workOrderPathname.includes('/work-order');

      if (!isOnWorkOrderPage) {
        const notificationMessage = {
          ...message,
          type: 'WORK_ORDER_CREATED',
          text: '你有一个新任务'
        };
        next(show_global_popup(notificationMessage));
      }
      break;
    case 'WORK_ORDER_REOPENED':
      console.log('WORK_ORDER_REOPENED', message);
      EventEmitter.emit(emitterEvent.WORK_ORDER_REOPENED, message);

      const workOrderPathnameReopened = window.location.pathname;
      const isOnNoNotificationPage = workOrderPathnameReopened.includes('/work-order') || workOrderPathnameReopened.includes('/client');

      if (!isOnNoNotificationPage) {
        const notificationMessageReopened = {
          ...message,
          type: 'WORK_ORDER_REOPENED',
          text: '你有一个任务被重新开启'
        };
        next(show_global_popup(notificationMessageReopened));
      }
      break;
    // 任务解锁提示
    case emitterEvent.TEAM_ACTIVITY_TODO_UNLOCK:
      EventEmitter.emit(type, message)
      break;
    case emitterEvent.TEAM_ACTIVITY_COMPLETE:
      EventEmitter.emit(emitterEvent.TEAM_ACTIVITY_COMPLETE, message);
      break;
    case 'TEAM_ACTIVITY_MEMBER_DOLL_BACK_IMAGE_CREATED':
      EventEmitter.emit(emitterEvent.TEAM_ACTIVITY_MEMBER_DOLL_BACK_IMAGE_CREATED, message);
      break;
    case 'TEAM_VOTE_ACTIVITY_START':
      EventEmitter.emit(emitterEvent.TEAM_VOTE_ACTIVITY_START, message);
      break;
    case 'TEAM_VOTE_ACTIVITY_END':
      EventEmitter.emit(emitterEvent.TEAM_VOTE_ACTIVITY_END, message);
      break;
    case 'TODAY_STORY_IMAGE_GENERATED':
      EventEmitter.emit(emitterEvent.TODAY_STORY_IMAGE_GENERATED, message);
      break;
    default:
      break;
  }
  next(handle_notification(message))
}
let timer = null;
// 服务端收到的消息
const receiveMessageList = [];
// 心跳检测
let heartBeatTimer = null;
// 心跳间隔
const HEART_BEAT_INTERVAL = 1000 * 10;
const joinedRooms = new Set();

function createSocketMiddleware(role, authId) {
  console.log('**********8createSocketMiddleware****', authId)
  let eventFlag = false;
  let socket = null;
  const createHistory = require('history').createBrowserHistory;
  let history = createHistory();

  // 监听网页关闭
  window.onbeforeunload = function () {
    console.log('网页关闭')
    socket && socket.close();
  }

  return store => next => action => {
    clearInterval(timer);
    clearInterval(heartBeatTimer);
    timer = setInterval(() => {
      if (receiveMessageList.length > 0) {
        next(message_update(receiveMessageList.shift()))
        EventEmitter.emit('SHOW_DOT_LOADING', true);
      }
      if (receiveMessageList.length === 0) {
        EventEmitter.emit('SHOW_DOT_LOADING', false);
      }
    }, 1500)
    heartBeatTimer = setInterval(() => {
      if (socket?.connected) {
        EventEmitter.emit('DISCONNECT_SOCKET', false);
      }
      else {
        EventEmitter.emit('DISCONNECT_SOCKET', true);
      }
    }, HEART_BEAT_INTERVAL)

    if (action.type === 'REGISTER_SOCKET_EVENT') {
      socket = action.socket;
    }
    if (!eventFlag && socket) {
      console.log('register socket event listener', socket.listeners())
      eventFlag = true;
      socket.on('connect', () => {
        console.log('socket connect success!!!!')
        EventEmitter.emit('DISCONNECT_SOCKET', false);
        joinedRooms.forEach(roomName => {
          socket.emit(JOIN_ROOM, { roomName }, (ack) => {
            console.log('REJOIN ROOM ON RECONNECT:', roomName, ack);
          });
        });
        EventEmitter.emit(emitterEvent.SOCKET_CONNECTED);
      })
      console.log('register socket event', action.socket);
      socket.on(CHAT_TO_ONE, (data) => {
        console.log('chatToOne from server:', data, socket.id)
        // 根据fromUserId判断 当前接受到的消息属于不同设备发出去的消息还是属于接受到的设备
        const messageFromWhere = isNeedUpdateMessage(store, data, changeName(role));
        if (messageFromWhere) {
          // 机器人的消息
          if (data.messageType === 'ROBOT_CHAT') {
            receiveMessageList.push(data);
            EventEmitter.emit('ON_RECEIVE_MSG', data)
          }
          // 需要撤回的消息
          else if (data.messageType === 'WITHDRAW') {
            next(message_withdraw({ ...data, withdrawFlag: true }))
          }
          else {
            next(message_update(data))
            EventEmitter.emit('ON_RECEIVE_MSG', data)
          }
        } else {
          EventEmitter.emit('UPDATE_UNREAD_MESSAGE', { ...data });
        }
      })
      socket.on(CALL_TO_ONE, (data) => {
        console.log('callToOne:', data)
        const callStatus = JSON.parse(data.message).callStatus;
        (callStatus === 'HANG_UP') && EventEmitter.emit(emitterEvent.HANG_UP);
        const messageFromWhere = isNeedUpdateMessage(store, data, changeName(role));
        messageFromWhere && next(message_update(data));
      })
      socket.on(NOTIFICATION, (data) => {
        console.log('NOTIFICATION:', data)
        let message = JSON.parse(data.message);
        handleNotification(history, message, next);
      })
      socket.on(FILE_UPLOAD, (data) => {
        console.log('notification:', data)
        next(message_update(data));
        const messageFromWhere = isNeedUpdateMessage(store, data, changeName(role));
        EventEmitter.emit('UPDATE_UNREAD_MESSAGE', { ...data });
      })

      socket.on('disconnect', (reason) => {
        console.log('disconnect', reason);
        // 断连接增加状态
        EventEmitter.emit('DISCONNECT_SOCKET', true);
      })
      console.log('register socket event listener', socket.listeners(CHAT_TO_ONE))
    }
    if (socket) {
      if (!socket?.connected) {
        socket.open();
      }
        switch (action.type) {
          case JOIN_ROOM:
            console.log("JOIN ROOM: ", action.value);
            joinedRooms.add(action.value);
            socket.emit(JOIN_ROOM, {roomName: action.value}, (ack) => {
              console.log("JOIN ROOM RESPONSE: ", ack);
            });
            break;
          case LEAVE_ROOM:
            if (isRoomPinned(action.value)) {
              console.log("LEAVE ROOM skipped, room is pinned: ", action.value);
              break;
            }
            console.log("LEAVE ROOM: ", action.value);
            joinedRooms.delete(action.value);
            socket.emit(LEAVE_ROOM, {roomName: action.value}, (ack) => {
              console.log("LEAVE ROOM RESPONSE: ", ack);
            });
          break;
        case CHAT_TO_ONE:
          console.log('CHAT TO ONE:', action.value)
          console.warn('emit call flag to server, socket', socket.connected, socket)
          socket.emit(CHAT_TO_ONE, action.value, (ack) => {
            if (ack && ack === 'success') {
              next(message_update({ ...action.value, onSendSuccess: true }))
            }
            else {
              // 发送消息失败，可能的原因是socket物理连接可能还在，但是因为刷新后，后端的socket.id已经变了，所以发送消息失败
              next(message_update({ ...action.value, onSendSuccess: false }));
            }
          })
          break;
        case CALL_TO_ONE:
          console.log('emit call flag to server', action.value)
          socket.emit(CALL_TO_ONE, action.value, (ack) => console.log("callToOne ack data: ", ack))
          break;
        case LOGOUT_CHAT_CLOSE:
          socket.close();
          eventFlag = false;
          joinedRooms.clear();
          console.log('logout and disconnect socket!', socket, eventFlag)
          // socket.off();
          socket = null;
          break;
        default:
          break;
      }
    } else if (!socket) {
      const newSocket = reCreateSocket(store, authId)
      socket = newSocket;
    }
    return next(action);
  }
}

export default createSocketMiddleware
